import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { AgendaPreview } from "./AgendaPreview";
import { Button } from "@repo/ui/components/Base/Button";
import type { LetterHead, Team, Tenant } from "@repo/types";
import { generateMeetingExample } from "./meetingExample";
import { useMemo } from "react";

export interface LetterheadPreviewDialogProps {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  tenant?: Tenant;
  team?: Team;
  letterHead?: LetterHead;
  title?: string;
}

export const LetterheadPreviewDialog = ({
  open,
  setOpen,
  tenant,
  team,
  letterHead,
  title = "Preview Agenda",
}: LetterheadPreviewDialogProps) => {
  const meeting = useMemo(
    () => generateMeetingExample({ letterHead }),
    [letterHead]
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody className="h-[75vh]">
          <AgendaPreview
            enableLinks={false}
            tenant={tenant}
            team={team}
            meeting={meeting}
            letterHead={letterHead}
          />
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => setOpen?.(false)} variant="tertiary">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
